import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SheetService from "../services/SheetService";

const initialState = {
  tables: [],
  filters: [],
  rows: [],
  cols: [],
  target: "sales",
  pivotInfo: {
    rows: [],
    cols: [],
    filters: [],
    shouldRun: true,
  },
  tableData: {},
  reportResultOfPivot: {}
};

export const getInitialData = createAsyncThunk("sheet/getTables", async (dbInfo) => {
  const res = await SheetService.getInitialData(dbInfo);
  return res.data;
});

export const getTableData = createAsyncThunk("sheet/getTableData", async (table) => {
  const res = await SheetService.getTableData(table);
  let result = {};
  result[table] = res.data.data;
  return result;
});

export const pivot = createAsyncThunk("sheet/pivot", async (pivotInfo) => {
  const res = await SheetService.pivot(pivotInfo);
  return res.data;
});

export const sheetSlice = createSlice({
  name: "sheet",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setColumns: (state, action) => {
      state.cols = action.payload;
    },
    setRows: (state, action) => {
      state.rows = action.payload;
    },
    setPivotInfo: (state, action) => {
      const { kind, data, shouldRun } = action.payload;
      state.pivotInfo[kind] = data;
      if(shouldRun===undefined)
        state.pivotInfo.shouldRun = true;
      else 
        state.pivotInfo.shouldRun = false;
    },
    setPivotMember: (state, action) => {
      const {kind, rowIndex, dimension, member, relation} = action.payload;
      const newData = state.pivotInfo[kind].map((item, index) => {
        if(index === rowIndex) {
          const newItem = item.map(cellItem => {
            if(cellItem.dimension === dimension) return relation? {dimension, member, relation}:{dimension, member}
            return cellItem;
          })
          return newItem;
        }
        return item;
      })
      state.pivotInfo[kind] = newData;
      state.pivotInfo.shouldRun = true;
    },
    setReturnData(state, action) {
      const {data} = action.payload;
      state.reportResultOfPivot.data = data;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getInitialData.fulfilled, (state, action) => {
      const { data, success } = action.payload;
      if (success) {
        const formattedData = data.map(item => ({ id: item.name, content: item.root }));
        state.tables = formattedData;
        state.cols = [];
        state.rows = [];
        state.filters = formattedData;

        const pivotFiliterData = formattedData.map(item => ([{ dimension: item.id, member: "" }]));
        state.pivotInfo["filters"] = pivotFiliterData;
        state.pivotInfo["rows"] = [];
        state.pivotInfo["cols"] = [];
      } else {
        console.log("getInitialData failed");
      }
    })
    .addCase(getTableData.fulfilled, (state, action) => {
      for (const key in action.payload) {
        state.tableData[key] = action.payload[key];
      }
      return state;
    })
    .addCase(pivot.fulfilled, (state, action) => {
      state.reportResultOfPivot = action.payload.Return;
    });
  }
});

export const {
  setFilters,
  setColumns,
  setRows,
  setPivotInfo,
  setPivotMember,
  setReturnData
} = sheetSlice.actions;

export default sheetSlice.reducer;